export default __webpack_public_path__ + "static/media/5.85621f51.png";